// extracted by mini-css-extract-plugin
module.exports = {"graphic":"FAQGenesis_graphic_11O52"};